import { gql } from "@apollo/client";

export const SearchUsersQuery = gql`
  query Query($userSearch: UserSearchInput!) {
    searchUsers(userSearch: $userSearch) {
      nextCursorToken
      users {
        authMethod
        email
        firstName
        lastName
        username
        roles
        groups
        attributes
        status
        lastLogin
      }
    }
  }
`;
